import { type ReactNode } from 'react';

import { cx } from '@/lib/cx';

export interface MarcoTempo {
  id: string;
  titulo: ReactNode;
  quando: string;
  descricao?: ReactNode;
  tom?: 'marca' | 'sucesso' | 'perigo' | 'neutro';
}

const PONTOS = {
  marca: 'bg-marca',
  sucesso: 'bg-sucesso',
  perigo: 'bg-perigo',
  neutro: 'bg-borda-forte',
} as const;

/** Sequência de acontecimentos (eventos da nota, histórico). Ordem é a do array. */
export function LinhaDoTempo({ marcos }: { marcos: readonly MarcoTempo[] }) {
  return (
    <ol className="relative grid gap-5 border-l border-borda pl-5">
      {marcos.map((marco) => (
        <li key={marco.id} className="relative grid gap-0.5">
          <span
            aria-hidden
            className={cx(
              'absolute -left-5 top-1.5 -translate-x-1/2 size-2.5 rounded-pilula ring-4 ring-superficie-elevada',
              PONTOS[marco.tom ?? 'neutro'],
            )}
          />
          <div className="text-base font-medium">{marco.titulo}</div>
          <time className="text-xs text-texto-fraco tabular">{marco.quando}</time>
          {marco.descricao && <div className="text-sm text-texto-suave">{marco.descricao}</div>}
        </li>
      ))}
    </ol>
  );
}
